var render = function render(){var _vm=this,_c=_vm._self._c;return _c('j-modal',{attrs:{"title":_vm.title,"width":1200,"visible":_vm.visible,"maskClosable":false,"switchFullscreen":"","okButtonProps":{ class:{'jee-hidden': _vm.disableSubmit} }},on:{"ok":_vm.handleOk,"cancel":_vm.handleCancel}},[_c('ces-order-main-form',{ref:"realForm",attrs:{"disabled":_vm.disableSubmit},on:{"ok":_vm.submitCallback}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }